import { omit } from 'lodash';
import dimensions from './dimensions';
import breakpoints from './breakpoints';
import { colorsSource, lightThemeColors, darkThemeColors } from './colors';
import { spacing, borderRadius } from './spacing';
import font from './font';
import motion from './motion';
import { elevationDark, elevationLight } from './elevation';
import { SCREEN_SIZE } from './screen';

export const THEME_NAME_DARK = 'dark';
export const THEME_NAME_LIGHT = 'light';

const colors = {
  colorsSource,
  themeColors: {
    lightThemeColors,
    darkThemeColors,
  },
};

export const theme = {
  borderRadius,
  breakpoints,
  colors,
  dimensions,
  font,
  motion,
  spacing,
  screenSize: SCREEN_SIZE.LARGE,
};

export const darkTheme = {
  themeName: THEME_NAME_DARK,
  isDarkTheme: true,
  ...omit(theme, ['themeColors']),
  colors: {
    ...darkThemeColors,
    colorsSource,
  },
  elevation: elevationDark,
};

export const lightTheme = {
  themeName: THEME_NAME_LIGHT,
  isLightTheme: true,
  ...omit(theme, ['themeColors']),
  colors: {
    ...lightThemeColors,
    colorsSource,
  },
  elevation: elevationLight,
};

export const defaultThemes = {
  lightTheme,
  darkTheme,
};
